import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';

import { useAuthToken } from 'hooks/useAuthToken';
import { useQuery } from 'hooks/useQuery';
import React, { useEffect, useState } from 'react';

import FormGuest from './FormGuest';
import Logo from 'components/Logo';
import { getTicketInfo } from 'services/events';
import { months } from 'pages/PaymentLink/options';
import styled from '@emotion/styled';
import { QRCodeCanvas } from 'qrcode.react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const BoxContainer = styled(Box)({
  maxWidth: 1000,
  margin: '0 auto'
})

const ResponseContainer = styled(Box)({
  marginTop: '2rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '20px'
})

const FormGuestEvent = ({ setCurrentBrand }) => {

  const query = useQuery()
  const currentBrand = query.get('b')
  const ticketUuid = query.get('t')

  const [loadingInfo, setLoadingInfo] = useState(true);
  const [ticketInfo, setTicketInfo] = useState({});
  const [messageError, setMessageError] = useState();
  const [dataResponse, setDataResponse] = useState();

  const { getAuthToken, isLoadingToken } = useAuthToken();

  useEffect(() => {
    setCurrentBrand(currentBrand);
    localStorage.setItem("current_brand", currentBrand);

    getAuthToken();

  }, [])

  useEffect(() => {
    if (ticketUuid) {
      setMessageError();
      getTicketInfo(ticketUuid)
        .then(({ data }) => {
          setTicketInfo(data?.data);
        })
        .catch(() => {
          setMessageError('Tenemos un error intenta de nuevo')
        })
        .finally(() => setLoadingInfo(false))
    }
  }, [ticketUuid])

  const getDateFormat = (date) => {
    const time = new Date(date);

    return time?.getDate() + 1 + ' de ' + months[time?.getMonth()] + ' del ' + time?.getFullYear();
  }

  const getDates = (date1, date2, hour1, hour2) => {

    if (date1 && date2 && hour1 && hour2) {
      const time1 = new Date(date1 + " " + hour1);
      const time2 = new Date(date2 + " " + hour2);

      if(months[time1?.getMonth()] === months[time2?.getMonth()]){
        return format(time1, 'd')  + " al " + format(time2, 'd') + " de " + format(time1, 'MMMM', { locale: es }) + " de " + format(time1, 'Y')
        + ', desde las ' + format(time1, 'h:mm') + 'am hasta las ' + format(time2, 'h:mm') + 'pm'
      }

      return format(time1, 'd')  + " de " + format(time1, 'MMMM', { locale: es }) + " al " + format(time2, 'd') + " de " + format(time2, 'MMMM', { locale: es }) + " de " + format(time1, 'Y')
      + ', desde las ' + format(time1, 'h:mm') + 'am hasta las ' + format(time2, 'h:mm') + 'pm'
    }

    return "(Fecha por definir)";

  }

  if(loadingInfo || isLoadingToken) {
    return (
      <Box margin={'0 auto'} marginTop={"30vh"} width={'40px'} ><CircularProgress /></Box>
    )
  }

  if (messageError) {
    return (
      <Grid>
        <Grid item xs={12}>
          <Logo />
        </Grid>
        <Grid item xs={12}>
          <Box textAlign={'center'} marginTop={"30vh"} >
            <Typography variant='h4' >{messageError}</Typography>
          </Box>
        </Grid>
      </Grid>
    )
  }

  if (dataResponse) {
    return (
      <Grid padding={2}>
        <Grid item xs={12}>
          <Box alignContent={'center'}>
            <Logo />
            <ResponseContainer  >
              <Typography variant='h4' color={'primary'} >¡Preparate para la expedición {currentBrand == 1 ? 'Bodytech' : 'Athletic'}!</Typography>

              <Box textAlign={'center'}>
              <Typography maxWidth={'700px'}>
              {dataResponse?.guest?.first_name} {dataResponse?.guest?.young_first_name !== null ? 'y ' + dataResponse?.guest?.young_first_name : ''} ¡El kit {dataResponse?.guest?.young_first_name !== null ? 'les' : 'te'}
                {" "} espera! Con este QR y tu documento podrás reclamarlo del dia {getDates(dataResponse?.kit?.date, dataResponse?.kit?.date_end, dataResponse?.kit?.hour_start, dataResponse?.kit?.hour_end)} en {dataResponse?.kit?.address}.
              </Typography>
               <br />
                <QRCodeCanvas value={dataResponse?.ticket} size={180} />
              </Box>

              <Button variant='contained' href={dataResponse?.pdf} target='_blank'>
                Descargar PDF
              </Button>
            </ResponseContainer>

          </Box>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container spacing={2} style={{padding: '20px'}} >
      <Grid item xs={12}>
        <Logo />
      </Grid>

      <Grid item xs={12}>
        <BoxContainer>
          <Typography
            variant='h4'
            style={{fontSize: 20, textAlign: 'right', marginBottom: 10}}
          >TICKET: {ticketInfo.ticket_id}</Typography>

          <Typography>{ticketInfo?.event?.address} - {ticketInfo?.event?.city_name}</Typography>
          <Typography>{getDateFormat(ticketInfo?.event?.date)}</Typography>
          <Typography>{ticketInfo?.product_name}</Typography>
        </BoxContainer>
      </Grid>

      <Grid item xs={12}>
        <BoxContainer>
          <FormGuest
            guest={ticketInfo?.guest}
            sizes={ticketInfo?.sizes}
            event={ticketInfo?.event}
            blood={ticketInfo?.blood_group}
            isYoung={ticketInfo?.is_young}
            setDataResponse={setDataResponse}
          />
        </BoxContainer>
      </Grid>
    </Grid>

  )

}

export default FormGuestEvent;
